<template>
<div>
  <div class="contact__info text-neutral">
    <div class="first-col">
      <span class="fas fa-envelope"></span>
    </div>

    <div>
      <div>
      <h2>{{ company.name }}</h2>

      <p class="text-small text-neutral">
        Ihr Immobilienmakler in den Metropolregionen Hamburg und Berlin
      </p>

      <ul class="text-small list-unstyled">
        <li>
          <span class="text-primary">Hauptsitz:</span>{{ company.street }} <br/>
          <span class="text-primary"></span>{{ company.zip }} {{ company.city }}
        </li>

        <li>
          <span class="text-primary">Zweigstelle:</span>{{ company.street1 }}<br/>
          <span class="text-primary"></span>{{ company.zip1 }} {{ company.city1 }}
        </li>


        <li>
          <span class="text-primary">Telefon:</span>
          <p>
            Hamburg: <a :href="'tel:' + company.phone" class="text-neutral">
              {{ company.phone }}
          </a><br />
            Berlin: <a :href="'tel:' + company.phone1" class="text-neutral">
              {{ company.phone1 }}
          </a></p>
        </li>

        <li>
          <span class="text-primary">E-Mail:</span>
          <a class="link--arrow-right" :href="'mailto:' + company.email">
            E-Mail senden</a>
        </li>
      </ul>
      </div>
    </div>
  </div>

  <div class="contact__info">
    <div class="first-col">
      <span class="fas fa-map-marker-alt"></span>
    </div>

    <div>
      <div class="text-neutral">
        <h2>Ihr Weg zu uns</h2>

        <p class="text-small text-neutral">
          Nehmen Sie mit uns Kontakt auf und vereinbaren Sie einen persönlichen Beratungstermin. Das Team um Michael Aumer freut sich auf Sie.
        </p>

        <a :href="'https://www.google.de/maps?daddr=' + encodeURI(company.street + ', ' + company.zip + '+' + company.city) + '&saddr='"
            title="Route jetzt berechnen"
            target="_blank"
            class="link--arrow-right">
              Route jetzt berechnen</a>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: "ContactCompanyInfo",

  computed: {
    company() {
      return this.$yeti.company();
    }
  },

  methods: {
    onMapLoad(o) {
      o.L.marker(o.defaultCenter).addTo(o.map);
      this.mapCenter = o.defaultCenter;
    }
  }
}
</script>
